module.exports = __webpack_public_path__ + "static/img/6.3c510a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting602/images/6.png
// module id = 2rw2
// module chunks = 4